// src/stockx/base/FollowingIcon.tsx
import { Icon } from "@chakra-ui/icons";
import { jsx, jsxs } from "react/jsx-runtime";
var FollowingIcon = ({ colorized, ...props }) => /* @__PURE__ */ jsxs(Icon, { viewBox: "0 0 50 50", ...props, children: [
  colorized && /* @__PURE__ */ jsx(
    "path",
    {
      d: "M25 42.89C34.8804 42.89 42.89 34.8804 42.89 25C42.89 15.1196 34.8804 7.10999 25 7.10999C15.1196 7.10999 7.10999 15.1196 7.10999 25C7.10999 34.8804 15.1196 42.89 25 42.89Z",
      fill: "#D5D2C7"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M34.6 22.8C34.6 19.99 32.32 17.72 29.52 17.72C27.55 17.72 26.07 19.21 25 20.79C23.92 19.12 22.45 17.72 20.48 17.72C17.67 17.72 15.4 20 15.4 22.8C15.4 23.44 15.52 24.05 15.74 24.62C16.61 27.59 25 34.81 25 34.81C25 34.81 33.39 27.59 34.27 24.63C34.48 24.06 34.6 23.45 34.6 22.8Z",
      fill: colorized ? "#016341" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M25 44.01C14.52 44.01 5.98999 35.48 5.98999 25C5.98999 14.52 14.52 5.98999 25 5.98999C35.48 5.98999 44.01 14.52 44.01 25C44.01 35.48 35.48 44.01 25 44.01ZM25 8.23999C15.76 8.23999 8.23999 15.76 8.23999 25C8.23999 34.24 15.76 41.76 25 41.76C34.24 41.76 41.76 34.24 41.76 25C41.76 15.76 34.24 8.23999 25 8.23999Z",
      fill: colorized ? "black" : "currentColor"
    }
  )
] });
var FollowingIcon_default = FollowingIcon;

export {
  FollowingIcon_default
};
